"use client"

import { useMarketPopinInit } from "~/components/ui/MarketPopin/hooks"

function MarketPopinInit({ marketPopInDisable }: { marketPopInDisable: boolean }) {
  useMarketPopinInit(marketPopInDisable)
  return <></>
}

export default MarketPopinInit
